import { render } from "./VestingSchedule.vue?vue&type=template&id=5597a4c0&scoped=true"
import script from "./VestingSchedule.vue?vue&type=script&lang=js"
export * from "./VestingSchedule.vue?vue&type=script&lang=js"

import "./VestingSchedule.vue?vue&type=style&index=0&id=5597a4c0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5597a4c0"]])

export default __exports__